// External libraries
import { css } from '@emotion/core';

const cardSubFieldsContainerStyleOverrides = css`
  flex-grow: 1;
  width: 100%;
`;

const cvvIconStyleOverrides = css`
  pointer-events: none;
`;

export { cardSubFieldsContainerStyleOverrides, cvvIconStyleOverrides };
